/* eslint-disable no-param-reassign */
import axios from "axios";

const ROOT_URL = "https://apis.voicebase.com/";

export default (token, mediaId, baseUrl = "v3", accountId) => {
  if (!/^http/.test(baseUrl)) {
    baseUrl = ROOT_URL + baseUrl;
  }

  const url = `${baseUrl}/media/${mediaId}/streams`;
  return axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(accountId && { "VoiceBase-Account-ID": accountId }),
      },
    })
    .then((response) => {
      let streamURL = null;
      if (response.data && response.data.streams) {
        // V3 has a different format...this code needs to be in a better spot...
        const streams = response.data.streams;
        if (streams.length) {
          // v3 - streams is Array<{streamName:string, steramLocation:string}>
          const sources = streams.reduce((returnObject, stream) => {
            Object.assign(returnObject, {
              [stream.streamName]: stream.streamLocation,
            });
            return returnObject;
          }, {});
          streamURL = sources.redacted || sources.original || streamURL;
        } else {
          // v2 - streams is string
          streamURL = streams.audio || streams.original || streamURL;
        }
      }

      return streamURL;
    });
};
